const SuccessCircleIcon = ({ ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <circle cx='8.572' cy='8.574' r='7.714' fill='#1B7938'></circle>
      <path
        fill='#DFF1E4'
        d='M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0M7.879 10.776l-2-2.001a.772.772 0 1 0-1.091 1.092l2.546 2.545a.77.77 0 0 0 1.091 0l5.272-5.272a.772.772 0 1 0-1.09-1.092z'
      ></path>
    </svg>
  );
};

export default SuccessCircleIcon;
